module.exports = __webpack_public_path__ + "media/images/icons/flags/HN-44c4401b7e3a14c14d85a4fd362fcd68.svg";